import { FCWithChildren } from '@types';
import React from 'react';

const NonWifiPasswordBody: FCWithChildren = () => {
  return (
    <div>
      <p className="py-2">
        This is a Wired-only site with no additional Wi-Fi access administered through this portal.
      </p>
      <p className="py-2">
        Add the MAC Address of your router or wired device in the My Devices page and then connect
        to an ethernet jack or port to access the internet.
      </p>
    </div>
  );
};

export default NonWifiPasswordBody;
